export const host_type = process.env.REACT_APP_HOST_TYPE;

let api_connection = '';
let portal = '';
let chat = '';
let only_chrome = '';
let content_sizes = '';

switch(host_type)
{
    case("dev"):
    {
        api_connection = process.env.REACT_APP_SERVER_HOST_DEV + "/" + process.env.REACT_APP_SERVER_API;
        portal = process.env.REACT_APP_PORTAL_URL;
        chat = process.env.REACT_APP_CHAT_URL;
        only_chrome = process.env.REACT_APP_ONLY_ALLOW_CHROME;
        content_sizes = process.env.REACT_APP_CONTENT_SIZES;
        break;
    }

    case("live"):
    {
        api_connection = process.env.REACT_APP_SERVER_HOST_LIVE + "/" + process.env.REACT_APP_SERVER_API;
        portal = process.env.REACT_APP_PORTAL_URL;
        chat = process.env.REACT_APP_CHAT_URL;
        only_chrome = process.env.REACT_APP_ONLY_ALLOW_CHROME;
        content_sizes = process.env.REACT_APP_CONTENT_SIZES
        break;
    }
    
    case("local"):
    default:
    {
        api_connection = process.env.REACT_APP_SERVER_HOST_LOCAL + ":" + process.env.REACT_APP_SERVER_PORT + "/" + process.env.REACT_APP_SERVER_API;
        portal = process.env.REACT_APP_PORTAL_URL;
        chat = process.env.REACT_APP_CHAT_URL;
        only_chrome = process.env.REACT_APP_ONLY_ALLOW_CHROME;
        content_sizes = process.env.REACT_APP_CONTENT_SIZES;
    }
}
export const server_connection = api_connection;
export const portal_url = portal;
export const chat_url = chat;
export const only_allow_chrome = only_chrome === 'true' ? true : false;
export const assignment_content_sizes = content_sizes;



// WEBPACK FOOTER //
// src/config.js